import { Color, DoubleSide, MeshPhysicalMaterial } from 'three';

export function createAlignerMaterial() {
  const material = new MeshPhysicalMaterial({
    color: new Color('#4dd8ff'),
    side: DoubleSide,
    transparent: true,
    opacity: 0.45,
    roughness: 0.15,
    metalness: 0.0,
    transmission: 0.8,
    thickness: 0.3,
    clearcoat: 0.35,
    clearcoatRoughness: 0.05,
    ior: 1.45,
  });

  material.depthWrite = false;
  material.depthTest = true;
  material.emissive.set('#30c8ff');
  material.emissiveIntensity = 0.12;
  material.polygonOffset = true;
  material.polygonOffsetFactor = -1;
  material.polygonOffsetUnits = -1;

  return material;
}

